import api from "../..";
import { uploadFile } from "../../file/uploadFile";
import type { SignRequestBody } from "../../file/types";
import type { Video, PostVideoBody, PostVideoParams } from "./types";

export const postVideo = async ({ videoFile, coverFile, description }: PostVideoParams): Promise<boolean> => {

  const videoSignBody: SignRequestBody = {
    item_type: "course",
    item_id: Date.now(),
    object_name: videoFile.name,
    object_type: "video",
    object_size: videoFile.size,
  };

  const videoKey = await uploadFile({
    file: videoFile,
    signBody: videoSignBody,
  });

  const coverSignBody: SignRequestBody = {
    item_type: "course",
    item_id: Date.now(),
    object_name: coverFile.name,
    object_type: "image",
    object_size: coverFile.size,
  };

  const coverKey = await uploadFile({
    file: coverFile,
    signBody: coverSignBody,
  });

  const body: PostVideoBody = {
    description,
    content: videoKey,
    cover_image: coverKey,
  };

  return await api.post("/admin/video/", body)
  .then(() => true)
  .catch(() => false);
};